<template>
    <div>
        <el-form :rules="rules" ref="ruleForm" :model="editData" label-width="110px" size="mini">
            <el-form-item prop="name" class="lable-width" label="业务名称">
                <el-input class="input-width"  clearable v-model="editData.name"></el-input>
            </el-form-item>
            <el-form-item prop="ywlx" class="lable-width" label="业务类型">
                <el-input class="input-width"  clearable v-model="editData.ywlx"></el-input>

            </el-form-item>
            <el-form-item  class="slable-width" label="回推类型">
                <el-input class="sinput-width"  clearable v-model="editData.nextType"></el-input>

            </el-form-item>
            <el-form-item prop="ywlxRes" class="lable-width" label="操作类型">
                <el-input class="input-width"  clearable v-model="editData.ywlxRes"></el-input>

            </el-form-item>
            <el-form-item class="lable-width" label="动态SQL">
                <el-input  type="textarea"  class="input-width" clearable v-model="editData.sql"></el-input>
            </el-form-item>
            <el-form-item  label="是否结束">
                <div style="margin-left: 46px">
                    <el-radio v-model="editData.isOver" :label="1">是</el-radio>
                    <el-radio v-model="editData.isOver" :label="0">否</el-radio>
                </div>
            </el-form-item>
            <el-form-item class="lable-width" label="描述">
                <el-input  type="textarea"  class="input-width" clearable v-model="editData.describe"></el-input>
            </el-form-item>
            <el-form-item prop="consumerName" class="lable-width" label="消费服务名称">
                <el-select class="input-width" v-model="editData.consumerName" placeholder="请选择消费服务名称">
                    <el-option v-for="val in consumername" :key="val.id" :label="val.name" :value="val.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="lable-width" label="录入人">
                <el-input class="input-width" disabled clearable v-model="editData.lruname"></el-input>
            </el-form-item>
            <el-form-item class="lable-width" label="创建时间">
                <el-input class="input-width" disabled clearable v-model="editData.createTime"></el-input>
            </el-form-item>
            <el-form-item  label="是否启用">
                <div style="margin-left: 46px">
                    <el-radio v-model="editData.state" :label="1">是</el-radio>
                    <el-radio v-model="editData.state" :label="0">否</el-radio>
                </div>
            </el-form-item>
            <!--            <el-form-item  label="是否继续">-->
            <!--                <div style="margin-left: 46px">-->
            <!--                    <el-radio v-model="editData.isNext" :label="1">是</el-radio>-->
            <!--                    <el-radio v-model="editData.isNext" :label="0">否</el-radio>-->
            <!--                </div>-->
            <!--            </el-form-item>-->
            <el-form-item class="lable-width" style="margin-left: 0">
                <el-button style="margin-left: 0" type="primary" @click="onSubmit(editData)">{{$t('button_save')}}</el-button>
                <el-button type="primary" @click="close">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import * as API from "../api";
    import {mapActions} from "vuex";
    export default {
        name: 'BusinessEntry',
        props:{

            editData:{
    type:Object
}
        },
        data(){
            return{
                consumername:[],
                rules: {
                    name: [
                        { required: true, message: '请输入业务名称', trigger: 'blur' },

                    ],
                    ywlx: [
                        { required: true, message: '请输入业务类型', trigger: 'blur' }
                    ],
                    ywlxRes: [
                        { required: true, message: '请输入回推类型', trigger: 'blur' }
                    ],
                    consumerName: [
                        {  required: true, message: '请选择消费名称', trigger: 'change' }
                    ],

                }
            }
        },
        watch:{
        },
        mounted(){
            this.getConsumerServerDropDownList()

        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            //消费服务下拉查询
            async getConsumerServerDropDownList() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                }
                let res = await API.getConsumerServerDropDownList(params);
                if (res.code == 1) {
                    this.consumername=res.list
                    // console.log(res)
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //业务配置保存
            async saveServiceConfig() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    id:this.editData.id,
                    name:this.editData.name,
                    consumerId:this.editData.consumerId,
                    sql:this.editData.sql,
                    state:this.editData.state,
                    ywlxOld:this.editData.ywlxOld,
                    ywlx:this.editData.ywlx,
                    ywlxRes:this.editData.ywlxRes,
                    describe:this.editData.describe,
                    isOver:this.editData.isOver,
                    nextType:this.editData.nextType
                    // isNext:this.editData.isNext
                }
                let res = await API.saveServiceConfig(params);
                if (res.code == 1) {
                    this.$emit('getserviceconfiglist')
                    this.$emit('close')
                    this.$message({
                        message: res.message,
                        type: 'success'
                    });

                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            close(){
    this.$emit('close')
            },

            onSubmit(editData){
//获取对应ID
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        // console.log(this.editData.xfname)

                        let add1=this.consumername.filter(item=>{
                           return  item.name==this.editData.consumerName
                        })
                        // console.log(add1)
                        this.editData.consumerId=add1[0].id
                        this.saveServiceConfig()
                    } else {
                        // console.log('error submit!!');
                        return false;
                    }
                });


            },


        }
    }
</script>
<style lang="scss" scoped>
    /deep/{
        .lable-width .el-form-item__content{
            margin-left: 0 !important;
        }
        .el-textarea__inner{
            height: 100px !important;
            color: #000000 !important;
            /*font-weight: 600 !important;*/
            font-size: inherit !important;
        }
        .el-form-item__error{
            left: 50% !important;
        }
    }
    .lable-width{
        text-align: center;
    }
    .slable-width{

    }
    .dialog-footer{
        display: flex;
        justify-content: center;
        align-items: center;
        /*text-align: center;*/
        margin-top: 12px;
    }
    .input-width{
        /*text-align: center;*/
        width: 18.571rem;
    }
    .sinput-width{
        width: 150px;
        margin-left: 28px;
    }
</style>